import type { EnumMapper } from '../types/common.type';

/**
 * Constants representing different confirmation configurations.
 * Replaces EConfirmConfig enum with const assertion pattern.
 */
export const CONFIRM_CONFIG = {
  
} as const;

/**
 * Configuration for confirmation dialogs.
 * Maps each confirmation action to its corresponding title and content.
 */
export const CONFIRM_CONFIG_MAPPER: EnumMapper<{ title: string; content: string }> = {
  
};
